const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');

class RichRelevanceWishlistInstrumentationController extends RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService) {
        super($scope, $window, featureService, richRelevanceService);
        this.richRelevanceService = richRelevanceService;
        this.$window = $window;
    }

    sendInstrumentation() {
        this.richRelevanceService.getInformation()
            .then(() => {
                this.$window.R3_WISHLIST = new this.$window.r3_wishlist(); // eslint-disable-line new-cap
                this.$window.rr_flush_onload();

                this.$window.r3();
            });
    }
}

const richRelevanceWishlistInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceWishlistInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
    },
};

module.exports = {
    RichRelevanceWishlistInstrumentationController,
    richRelevanceWishlistInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-wishlist-instrumentation.component.js